import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Ui from '../../../presentationals/Admin/Recovery/IncommingPaymentReport.component'
import { _preFormatDate } from '../../../../utils/validation'
import { APIS } from '../../../../utils/api-factory'
import {
  getistByNumber, getlistByEmail, getlistByApplication, getIncomingPaymentByWeek,
  getIncomingPaymentByDate, getUserDetailByLoanId, saveCHequeNoticeApi,
  deductUserPaymentApi, getSourceOfEnach, deductUserPaymentByTechProcess
} from '../AdminActionCreator.component';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
import moment from 'moment'
class Incoming extends React.Component {
  constructor(props) {
    super(props);
    const { customcommonFilters } = props;
    this.state = {
      startDate: moment(customcommonFilters.fromDate).format('DD-MM-YYYY'),
      startDateToShow: customcommonFilters.fromDate ? new Date(customcommonFilters.fromDate) : null,
      endDate: moment(customcommonFilters.toDate).format('DD-MM-YYYY'),
      endDateToShow: customcommonFilters.toDate ? new Date(customcommonFilters.toDate) : null
    }
  }
  downloadFile() {
    let url = APIS.DOWNLOAD_INCOMING_PAYMENT_REPORT + this.state.startDate + '&dateTo=' + this.state.endDate
    window.location.href = url
  }
  dateFilter(e, type) {
    if (type == 'start') {
        this.setState({ startDate: _preFormatDate(e), startDateToShow: e })
                  this.props.setCommonFilters({ fromDate: moment(e).format('YYYY-MM-DD') });
      
    }
    if (type == 'end') {
     
        this.setState({ startDate: _preFormatDate(e), endDateToShow: e })
      this.props.setCommonFilters({ toDate: moment(e).format("YYYY-MM-DD") });
    }
  }



  componentDidUpdate(prevProps) {
    const { fromDate, toDate } = this.props.customcommonFilters;
    const { fromDate: prevFrom, toDate: prevTo } = prevProps.customcommonFilters;

    if (fromDate !== prevFrom || toDate !== prevTo) {
      const newStartDate = fromDate ? new Date(fromDate) : null;
      const newEndDate = toDate ? new Date(toDate) : null;

      if (
        newStartDate?.getTime() !== this.state.Start?.getTime() ||
        newEndDate?.getTime() !== this.state.End?.getTime()
      ) {
        this.setState({
          startDateToShow: newStartDate,
          endDateToShow: newEndDate,
          startDate: moment(fromDate).format('DD-MM-YYYY'),
          endDate: moment(toDate).format('DD-MM-YYYY'),
        });
      }
    }
  }


  deductionAmountHandler(type) {

    if (type == 'yes') {
      this.setState({
        disabled: true
      })
      if (this.state.source != 'techProcess') {
        deductUserPaymentApi(
          this.state.loanIdForDeduction,
          this.state.amountForDeduction,
          '',
          callBack => {
            if (callBack == 'success') {
              this.setState({
                popupState: true,
                popupStatus: 'success',
                amountDeductionPopupState: false,
                disabled: false
              })
              this.removePopup()
            } else {
              this.setState({
                popupState: true,
                popupStatus: 'Please try again',
                amountDeductionPopupState: false,
                disabled: false
              })
              this.removePopup()
            }
          }
        )
      } else {
        deductUserPaymentByTechProcess(
          this.state.loanIdForDeduction,
          this.state.amountForDeduction,
          this.state.dateTechProcess,
          callBack => {
            if (callBack == 'success') {
              this.setState({
                popupState: true,
                popupStatus: 'success',
                amountDeductionPopupState: false,
                disabled: false
              })
              this.removePopup()
            } else {
              this.setState({
                popupState: true,
                popupStatus: 'Please try again',
                amountDeductionPopupState: false,
                disabled: false
              })
              this.removePopup()
            }
          }
        )
      }
    } else if (type == 'no') {
      this.setState({ amountDeductionPopupState: false })
    }
    // if (type == 'yes') {
    //     this.setState({
    //         disabled: true
    //     })
    //     deductUserPaymentApi(this.state.loanIdForDeduction, this.state.amountForDeduction,
    //         (callBack) => {
    //             if (callBack == 'success') {
    //                 this.setState({
    //                     popupState: true,
    //                     popupStatus: 'success',
    //                     amountDeductionPopupState: false,
    //                     disabled: false
    //                 })
    //                 this.removePopup();
    //             } else {
    //                 this.setState({
    //                     popupState: true,
    //                     popupStatus: 'Please try again',
    //                     amountDeductionPopupState: false,
    //                     disabled: false
    //                 })
    //                 this.removePopup();
    //             }
    //         })
    // } else if (type == 'no') {
    //     this.setState({ amountDeductionPopupState: false })
    // }
  }

  render() {
    return (
      <div>
        <Ui
          startDate={this.state.startDate}
          startDateToShow={this.state.startDateToShow}
          endDate={this.state.endDate}
          endDateToShow={this.state.endDateToShow}
          downloadFile={this.downloadFile.bind(this)}
          dateFilter={this.dateFilter.bind(this)}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ FilterReduce }) => {
  return {
    customcommonFilters: FilterReduce.commonFilters
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({}, dispatch),
    setCommonFilters: (payload) => dispatch({ type: FILTER_ACTION, payload })
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Incoming);